import { ClerkProvider } from "@clerk/clerk-react"
import "./src/styles/styles.scss"
// Clerk publishable key - loaded from environment
const CLERK_KEY = process.env.GATSBY_CLERK_PUBLISHABLE_KEY

export const wrapPageElement = ({ element }) => {

  if (!CLERK_KEY) {
    return element
  }

  return (
    <ClerkProvider
      publishableKey={CLERK_KEY}
      afterSignInUrl="/"
      afterSignUpUrl="/"
      localization={{
        signUp: {
          start: {
            title: "Sign up to download free templates"
          }
        }
      }}
    >
      {element}
    </ClerkProvider>
  )
}
